import { useIntl } from 'react-intl';

import { Drawer } from 'antd';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import FilterContainer from '@src/components/FilterContainer';
import Delays from '@src/packages/workOrders/components/TaskDetails/Delays';

export interface DelaysDrawerData {
  divisionId?: string;
  executionId?: string;
}

interface DelaysDrawerProps extends DelaysDrawerData {
  open: boolean;
  onClose: () => void;
}

export const DelaysDrawer = ({
  divisionId,
  executionId,
  open,
  onClose,
}: DelaysDrawerProps) => {
  const intl = useIntl();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={null}
      closable={false}
      footer={null}
      destroyOnClose
    >
      <BoxContainer>
        <BoxContainer content fixed bottomBorder>
          <FilterContainer
            title={
              <Title.Header
                value={intl.formatMessage({ id: 'work.order.details.delays' })}
              />
            }
            goBack={onClose}
          />
        </BoxContainer>
        <BoxContainer content>
          <Delays divisionId={divisionId} executionId={executionId} readOnly />
        </BoxContainer>
      </BoxContainer>
    </Drawer>
  );
};

export default DelaysDrawer;
